import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import WorkflowView from '@/components/WorkflowView.vue';
import Workflow from '../Workflow';
import changeAirport from '../../js/airport/changeAirport';
import AirPortTicketInfo from '../../../components/AirPortTicketInfo.vue';

@Component({
  components: {
    WorkflowView,
    AirPortTicketInfo,
  },
  filters: {
    Date_DD(data: any) {
      return moment(data).format('YYYY-MM-DD');
    },
    Date_mm(data: any) {
      return moment(data).format('YYYY-MM-DD');
    },
    Date_HH(data: any) {
      return moment(data).format('YYYY-MM-DD HH:MM');
    },
    cardType(data: string) {
      return changeAirport.changeCertificates(data);
    },
  },
})
export default class TripInfoShow extends Vue {
  private $api: any;
  private isLoading: boolean = false;
  private active: number = 0; // tab页默认展示第一页
  private tripinfo: any = {}; // 出差信息
  private CurrentAirport: any = {}; // 机票信息
  private trip: any; // 列表页获取的行程信息
  private TripActivity: any = []; // 行程信息工作流 流程信息
  private AirActivity: any = []; // 机票信息工作流 流程信息
  private OperateReasons: any = []; // 退改签原因
  private ReturnPay: any = ''; // 退改费用

  private async created() {
    this.trip = JSON.parse(localStorage.getItem('tripInfo') || '');
    if (this.trip.TripTrafficId) {
      this.getTripInfo(); // 根据ID获取详情信息
      this.getTripWorkFlow(); // 获取行程信息和工作流信息
    }
    // 获取机票信息和工作流信息
    if (this.trip.Id) {
      this.getAirInfo();
      this.getAirWorkFlow();
      this.getReason();
    }
  }
  // 获取出差信息
  private async getTripInfo() {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
      duration: 0,
    });
    const params = {
      BusinessTripInfoId: this.trip.BusinessTripInfoId || '',
    };
    const result = await this.$api.httpGet('Membership/TripInfo/GetBusinessTripInfoById', params);
    if (result.Success) {
      if (result.Data) {
        this.tripinfo = result.Data;
      }
      this.$toast.clear();
      this.isLoading = true;
    } else {
      this.$toast.clear();
      this.isLoading = true;
      this.$dialog.alert({
        message: result.AllMessages,
      });
    }
  }

  // 获取机票信息
  private async getAirInfo() {
    this.$toast.loading({
      mask: true,
      message: '加载中...',
      duration: 0,
    });
    const model = {
      id: this.trip.Id,
    };
    const result = await this.$api.httpGet('basic/Ticket/QueryTicketInfoById', model);
    if (result.Success) {
      if (result.Data) {
        // 退改费用
        this.ReturnPay = result.Data.ReturnPay;
        // 机票信息
        if (result.Data.NewTicket) {
          this.CurrentAirport = result.Data.NewTicket;
          this.CurrentAirport.Depart = this.CurrentAirport.depart;
          this.CurrentAirport.DepartTime = this.CurrentAirport.departTime;
          this.CurrentAirport.DepartTerminal = this.CurrentAirport.departTerminal;
          this.CurrentAirport.DepartDate = this.CurrentAirport.departDate;
          this.CurrentAirport.Arrive = this.CurrentAirport.arrive;
          this.CurrentAirport.ArriveTime = this.CurrentAirport.arriveTime;
          this.CurrentAirport.ArriveTerminal = this.CurrentAirport.arriveTerminal;
          this.CurrentAirport.Airline = this.CurrentAirport.airline;
          this.CurrentAirport.No = this.CurrentAirport.no;
          this.CurrentAirport.Plane = this.CurrentAirport.plane;
          this.CurrentAirport.OnTimeRate = this.CurrentAirport.onTimeRate;
        }
      }
      this.$toast.clear();
      this.isLoading = true;
    } else {
      this.$toast.clear();
      this.isLoading = true;
      this.$dialog.alert({
        message: result.AllMessages,
      });
    }
  }

  // 获取退改签原因
  private async getReason() {
    if (this.trip.OperateType) {
        this.$toast.loading({
            mask: true,
            message: '加载中...',
            duration: 0,
        });
        const model = {
            UserTicketId: this.trip.Id,
            OperateType: this.trip.OperateType,
        };
        const result = await this.$api.httpPost('Membership/TripInfo/PostUserTicketReturnList', model);
        if (result.Success) {
            if (result.Data) {
                this.OperateReasons = result.Data;
            }
            this.$toast.clear();
            this.isLoading = true;
        } else {
            this.$toast.clear();
            this.isLoading = true;
            this.$dialog.alert({
                message: result.AllMessages,
            });
        }
    }
}

  // 获取行程工作流流程信息
  private getTripWorkFlow() {
    Workflow.GetWorkflowActivities('0033', this.trip.TripTrafficId, (response: any) => {
      this.TripActivity = response.Data;
    }, (error: any) => {
      this.$dialog.alert({
        message: error,
      });
    });
  }
  // 获取机票工作流流程信息
  private getAirWorkFlow() {
    Workflow.GetWorkflowActivities('0034', this.trip.Id, (response: any) => {
      this.AirActivity = response.Data;
    }, (error: any) => {
      this.$dialog.alert({
        message: error,
      });
    });
  }
}
